var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.license.used_at)?_c('Badge',{attrs:{"color":"secondary","large":_vm.large,"icon":"check-circle"}},[_vm._v("Used")]):_c('Badge',{attrs:{"color":"success","large":_vm.large,"icon":"circle-notch"}},[_vm._v("Available")])}
var staticRenderFns = []

export { render, staticRenderFns }